import {
    SET_TOPICS,
    ADD_TOPIC,
    SET_POSTS,
    ADD_POST,
    DELETE_POST,
    SET_LOADING,
    SET_ERROR,
  } from '../actions/chatActions';
  
  const initialState = {
    topics: [],
    posts: [],
    loading: false,
    error: null,
  };
  
  const chatReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_TOPICS:
        return {
          ...state,
          topics: action.payload,
        };
      case ADD_TOPIC:
        return {
          ...state,
          topics: [...state.topics, action.payload],
        };
      case SET_POSTS:
        return {
          ...state,
          posts: action.payload,
        };
      case ADD_POST: {
        console.log("Reducer: Adding post to state", action.payload);
        console.log(action);
        const newState = {
          ...state,
          posts: [...state.posts, action.payload]
        };
        console.log("New state after adding post:", newState);
        return newState;
      }
      case DELETE_POST:
        return {
          ...state,
          posts: state.posts.filter(post => post.id !== action.payload),
        };
      case SET_LOADING:
        return {
          ...state,
          loading: action.payload,
        };
      case SET_ERROR:
        return {
          ...state,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default chatReducer;